import { useContext, createContext } from "react";

export const ColorModeContext = createContext({
  toggleColorMode: (mode) => null,
});

export const useThemeMode = () => useContext(ColorModeContext);
